export default "__VITE_ASSET__DHqhOyn9__"